import React from 'react'
import { useParams } from 'react-router-dom'
import { isValidDealNumber } from 'utils/helperFns'
import errorPageMessages from 'constants/errorPageMessages'
import { useStyles } from '../../styles/material-styles/errorpageComponent'
import { ErrorCode, ErrorPageURLParams } from '../../ts/interfaces/ErrorPageComponent.interface'
import ErrorPageComponent from '../ErrorPage/ErrorPageComponent'

const ErrorPageURL: React.FC = () => {
  const { dealNumber, decisionType, decisionReason, emailId } = useParams<ErrorPageURLParams>()
  const restrictedDealNumbers = ['31128828', '12345678', '87654321'] // Add more restricted numbers as needed

  let errorCode: ErrorCode | null = null
  let errorMessage: string | null = null

  switch (true) {
    case !dealNumber:
      errorCode = 'MISSING_DEAL_NUMBER'
      errorMessage = errorPageMessages.MISSING_DEAL_NUMBER
      break

    case !decisionType || !decisionReason:
      errorCode = 'MISSING_PATH_PARAMS'
      errorMessage = errorPageMessages.MISSING_PATH_PARAMS
      break

    case !emailId:
      errorCode = 'MISSING_EMAIL_ID'
      errorMessage = errorPageMessages.MISSING_PATH_PARAMS
      break

    case dealNumber && !isValidDealNumber(dealNumber):
      errorCode = 'INVALID_DEAL_NUMBER'
      errorMessage = errorPageMessages.INVALID_DEAL
      break

    // Check if the deal number is restricted
    case dealNumber && restrictedDealNumbers.includes(dealNumber):
      errorCode = 'DEAL_RESTRICTED'
      errorMessage = errorPageMessages.DEAL_RESTRICTED
      break

    case dealNumber === 'INVALID_DEAL':
      errorCode = 'INVALID_DEAL'
      errorMessage = errorPageMessages.INVALID_DEAL
      break

    default:
      break
  }

  const { classes } = useStyles()

  return errorCode ? (
    <ErrorPageComponent
      errorCode={errorCode}
      title="Error"
      description={errorMessage ?? undefined}
      className={classes.error}
    />
  ) : (
    <div></div>
  )
}

export default ErrorPageURL
